import React from 'react';
import BrandPage from './BrandPage';

const MideaPage = () => <BrandPage brandSlug="midea" />;

export default MideaPage;
